// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n[data-v-4e6f274c]:export {\n  menuBg: #0F4C81;\n  menuText: #ffffff;\n  menuActiveText: #0F4C81;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.svg-icon[data-v-4e6f274c] {\n  vertical-align: middle;\n}\n.is-active[data-v-4e6f274c] {\n  transform: rotate(180deg);\n}", ""]);
// Exports
module.exports = exports;
